import { TOfferDataRequirement } from 'lendingApi/lapiOverrides.types';
import { DocumentRequirement } from '../DocumentRequirement/DocumentRequirement';

type TProps = {
  isOptional: boolean;
  isSubmitted: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
};
export const AgedDebtorReport = ({
  isOptional,
  isSubmitted,
  status,
}: TProps) => {
  return (
    <DocumentRequirement
      title="Aged debtor report"
      documentType="aged debtor report"
      isOptional={isOptional}
      isSubmitted={isSubmitted}
      status={status}
    >
      <p>
        This should be a list of invoices issued but yet to be paid, and ideally
        grouped by the number of days outstanding e.g. (30, 60, 90+ days).{' '}
        <a
          href="https://gocardless.com/guides/posts/aged-debtors-report/"
          target="_blank"
          rel="noreferrer"
        >
          Learn more
        </a>
      </p>
    </DocumentRequirement>
  );
};
